// Inline broadcast network wordmarks — no external CDN dependency.
// Each entry returns a small JSX wordmark that reads like the on-screen broadcast bug.
import React from "react";

const Pill = ({ children, bg = "#000", color = "#fff", w = "auto" }) => (
  <span
    style={{
      display: "inline-block",
      background: bg,
      color,
      padding: "3px 8px",
      letterSpacing: "0.06em",
      fontWeight: 900,
      fontFamily: "Anton, Impact, sans-serif",
      fontSize: 14,
      lineHeight: 1,
      minWidth: w,
      textAlign: "center",
    }}
  >
    {children}
  </span>
);

const NETWORKS = [
  {
    match: ["CBS"],
    label: "CBS",
    Mark: () => <Pill bg="#000" color="#fff">CBS</Pill>,
  },
  {
    match: ["FOX"],
    label: "FOX",
    Mark: () => <Pill bg="#003478" color="#fff">FOX</Pill>,
  },
  {
    match: ["NBC"],
    label: "NBC",
    Mark: () => (
      <Pill bg="#FFF" color="#000">
        <span style={{ color: "#E03A3E" }}>N</span>
        <span style={{ color: "#FF7600" }}>B</span>
        <span style={{ color: "#FFB81C" }}>C</span>
      </Pill>
    ),
  },
  {
    match: ["ESPN"],
    label: "ESPN",
    Mark: () => <Pill bg="#D2232A" color="#fff">ESPN</Pill>,
  },
  {
    match: ["ABC"],
    label: "ABC",
    Mark: () => <Pill bg="#000" color="#fff" w={36}>abc</Pill>,
  },
  {
    match: ["AMAZON", "PRIME"],
    label: "Prime Video",
    Mark: () => <Pill bg="#00A8E1" color="#fff">prime</Pill>,
  },
  {
    match: ["NETFLIX"],
    label: "Netflix",
    Mark: () => <Pill bg="#000" color="#E50914">N</Pill>,
  },
  {
    match: ["PEACOCK"],
    label: "Peacock",
    Mark: () => <Pill bg="#000" color="#fff">peacock</Pill>,
  },
  {
    match: ["NFL NETWORK", "NFLN"],
    label: "NFL Network",
    Mark: () => <Pill bg="#013369" color="#fff">NFL Net</Pill>,
  },
  {
    match: ["NFL"],
    label: "NFL",
    Mark: () => <Pill bg="#013369" color="#fff">NFL</Pill>,
  },
  {
    match: ["YOUTUBE"],
    label: "YouTube",
    Mark: () => <Pill bg="#FF0000" color="#fff">YT</Pill>,
  },
];

export function resolveNetwork(name) {
  if (!name) return null;
  const up = String(name).toUpperCase();
  for (const n of NETWORKS) {
    if (n.match.some((m) => up.includes(m))) return n;
  }
  // Unknown / TBD: return a styled fallback
  return {
    label: name,
    Mark: () => <Pill bg="#5C6166" color="#fff">{String(name).slice(0, 6)}</Pill>,
  };
}

// Official 2026 Tennessee Titans regular-season broadcast assignments
// (from https://www.tennesseetitans.com/schedule/).
export const TITANS_2026_BROADCAST_BY_WEEK = {
  1: "CBS",
  2: "FOX",
  3: "CBS",
  4: "CBS",
  5: "CBS",
  6: "FOX",
  7: "CBS",
  8: "CBS",
  10: "FOX",
  11: "FOX",
  12: "CBS",
  13: "CBS",
  14: "FOX",
  15: "CBS",
  16: "FOX",
  17: "CBS",
};
